import styles from './downloadAdjustmentNotePDFModal.module.css'
import { fileHelpers, usePDFActions } from '../../../../../features/files'
import { FileTile, FileType, Modal, ModalId } from '../../../../../features/ui'
import { useEffect, useState } from 'react'
import { SaleOperation } from '../../../../sales/state/types'
import { AdjustmentNotePDF } from '../adjustment-note-pdf/adjustmentNotePDF'
import { AdjustmentNote } from '../../../state/types'

type Props = {
    adjustmentNote?: AdjustmentNote
    operation?: SaleOperation
}

export const DownloadAdjustmentNotePDFModal = (props: Props) => {
    const { adjustmentNote, operation } = props

    const [pdfName, setPdfName] = useState<string>()

    const { adjustmentNoteFileName } = fileHelpers
    const { generatePDF, printPDF, isPrinting } = usePDFActions()

    useEffect(() => {
        adjustmentNote && operation && setPdfName(adjustmentNoteFileName(adjustmentNote.code, operation.code))
    }, [adjustmentNote, operation])

    const pdfId = 'adjustment-note-pdf'

    const onSubmit = () => {
        pdfName && generatePDF(pdfId, pdfName)
    }

    const renderHiddenPDF = () => adjustmentNote && operation ? (
        <div className={styles.hidden}>
            <AdjustmentNotePDF
                id={pdfId}
                adjustmentNote={adjustmentNote}
                operation={operation}
            />
        </div>
    ) : <></>

    return (
        <Modal
            modalId={ModalId.DOWNLOAD_ADJUSTMENT_NOTE_PDF}
            title="Descargar Nota de Crédito"
            submitLabel="Descargar"
            submitIcon="download"
            onSubmit={onSubmit}
            secondaryLabel="Imprimir"
            secondaryIcon="printer"
            disableSecondary={isPrinting || !pdfName}
            onSecondarySubmit={() => printPDF(pdfId)}
        >
            <FileTile fileType={FileType.PDF} fileName={pdfName} />
            {renderHiddenPDF()}
        </Modal>
    )
}
